import { get, post } from '../utils/request';

// 定义接口返回的数据类型





type BannerType = {
  purpose: 1 | 2,
  path: String
}

// 获取banner列表
export const getBannerList = (params: BannerType) => {
  return get<any>(`/web/get_banner_all_list?purpose=${params.purpose}&path=${params.path}`,params);
};


// 获取banner列表
export const getBannerTypeList = (params: BannerType) => {
  return get<any>(`/web/get_banner_all_list?purpose=${params.purpose}&path=${params.path}`, params);
};

// export const deleteCard = (data: any) => {
//   return post<any>('/card/save_delete_card', data);
// };
